import VuexPersistence from "vuex-persist";
import centralEventBus from "~/lib/centralEventBus";

const STORAGE_KEY = "unified-investor-vue-central-store";
const storage = window.sessionStorage;

export default function (store) {
  const vuexLocalStore = new VuexPersistence({
    key: STORAGE_KEY,
    storage,
  });

  vuexLocalStore.plugin(store);

  centralEventBus.$on("vuexPersistClearStorage", () =>
    storage.removeItem(STORAGE_KEY)
  );
}
